import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


const breadcrumbsStatic = [{
	name: 'Engineer',
	url: '/engineers',
	icon: 'gear',
}];

export default class Engineer extends Framework.Components.View {

	constructor(props) {
		super(props, 'notes');
		this.state.expectedLabor = null;
		this.state.finanpkey = null;
	}

	getExpectedLabor = (eLabor, pkey) => {
		if (this.state.expectedLabor !== eLabor)
		{
			this.setState({expectedLabor: eLabor})
		}
		if (this.state.finanpkey !== pkey)
		{
			this.setState({finanpkey: pkey})
		}
}

	render() {
		let {match, history, baseUrl} = this.props;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				// TODO, check where state is set in View, then can update this on state state change
				name:`${match.params.id}`,
				url: `/engineers/${match.params.id}`,
				icon: 'gear',
			}
		]);
		const tabStyle={
			fontSize:"9px"
		}
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>
				<Objects.EngineerInfo
					id={match.params.id}
					history={this.props.history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					getExpectedLabor={this.getExpectedLabor}
				/>
				<Tabs
					value={this.state.tab}
					onChange={this.handleTabChange}
					component={'div'}>

					<Tab style={tabStyle} label="Notes" value="notes"/>
					<Tab style={tabStyle} label="Financial" value="financial"/>
					<Tab style={tabStyle} label="Site Checklist" value="checklist"/>
					{/*<Tab style={tabStyle} label ="Change Log" value="changelog"/>*/}
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'notes'})}>
					<Objects.TicketNote
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'financial'})}>
					<Objects.Financial
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
						expectedLabor={this.state.expectedLabor}
						id={this.state.finanpkey}
					/>
				</div>
				<div className={classNames({'hidden': this.state.tab !== 'checklist'})}>
					<Objects.TicketCheckList
						parent={match.params.id}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={baseUrl}
						noDelete={false}
						goBack={true}
					/>
				</div>



			</div>
		)
	}
};
